var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#B4C08F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93212 10.5495L4.75765 8.38801C4.69689 8.32725 4.6665 8.24913 4.6665 8.15364C4.6665 8.05815 4.69689 7.98003 4.75765 7.91927L5.23942 7.45052C5.30018 7.38107 5.37614 7.34635 5.46728 7.34635C5.55843 7.34635 5.63872 7.38107 5.70817 7.45052L7.1665 8.90885L10.2915 5.78385C10.3609 5.71441 10.4412 5.67969 10.5324 5.67969C10.6235 5.67969 10.6995 5.71441 10.7602 5.78385L11.242 6.2526C11.3028 6.31337 11.3332 6.39149 11.3332 6.48698C11.3332 6.58246 11.3028 6.66059 11.242 6.72135L7.40087 10.5495C7.34011 10.6189 7.26198 10.6536 7.1665 10.6536C7.07101 10.6536 6.99289 10.6189 6.93212 10.5495Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIcon);
export default __webpack_public_path__ + "static/media/yes-icon.6efe39b5c5322a1fcc28bbf0e5d299d7.svg";
export { ForwardRef as ReactComponent };